module.exports = __webpack_public_path__ + "static/media/TN-Men-Tshirts-v2.0_OA.ec3ec51d.svg";